<template>
  <div :style="topologyHeight" class="flex-column">
    <div class="flex-fill">
      <preview @topoJump="topoJump"></preview>
    </div>
    <!-- <div>
      <a-table
        style="height: 250px;overflow-y: auto;background-color: #fff"
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="false"
        :scroll="{ x: true }"
        bordered
        class="j-table-force-wrap"
        ref="table"
        rowKey="id"
        size="small"
      >
        <span slot="alertName" slot-scope="alertName, record">{{ record.devId_dictText }}</span>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            @click="previewFile(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <span slot="summarySlot" slot-scope="text, record">
          <span style="margin-left:10px;">{{ text }}</span>
        </span>
        <span slot="levelSlot" slot-scope="text, record">
          <a-tag :color="$filterDictTextByCache('alert_level_color', text)">{{ record.alertLevel_dictText }}</a-tag>
        </span>
        <span slot="isAcknowledgementSlot" slot-scope="isAcknowledgement, record">
          <a-tag color="gray" v-if="record.isAcknowledgement == 0">未确认</a-tag>
          <a-tag color="#52c41a" v-else>已确认</a-tag>
        </span>
        <span slot="recoverySlot" slot-scope="isRecovery, record">
          <a-tag color="#ff4d4f" v-if="record.isRecovery == 0">未恢复</a-tag>
          <a-tag color="#52c41a" v-else>已恢复</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a :disabled="!record.devId" @click="devDetail(record)">设备详情</a>
          <a-divider type="vertical" />
          <a :disabled="!record.pointCode" @click="dataLine(record)">数据曲线</a>
          <a-divider type="vertical" />
          <a @click="alertLife(record)">告警变化</a>
        </span>
      </a-table>
    </div> -->
  </div>
</template>

<script type="text/javascript">
import preview from '@/components/TopoComp/preview'
import { getAction } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'TopoPreview',
  components: { preview },
  mixins: [JeecgListMixin, mixinDevice],
  data() {
    const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
    return {
      topologyHeight: {
        // height: window.innerHeight-150  + 'px',
        height: '100%'
      },
      curTopo: {},
      columns: [
        {
          title: '告警名称',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'alertName' }
        },
        {
          title: '告警时间',
          align: 'center',
          dataIndex: 'alertTime',
          width: 150,
          customRender: forceNowrap
        },
        {
          title: '告警信息',
          align: 'center',
          dataIndex: 'summary',
          align: 'left',
          scopedSlots: { customRender: 'summarySlot' }
        },
        {
          title: '告警等级',
          align: 'center',
          dataIndex: 'alertLevel',
          width: 100,
          scopedSlots: { customRender: 'levelSlot' }
        },
        {
          title: '是否确认',
          align: 'center',
          width: 100,
          dataIndex: 'isAcknowledgement',
          scopedSlots: { customRender: 'isAcknowledgementSlot' }
        },
        {
          title: '是否恢复',
          align: 'center',
          width: 100,
          dataIndex: 'isRecovery_dictText',
          scopedSlots: { customRender: 'recoverySlot' }
        },
        {
          title: '附件',
          align: 'center',
          width: 120,
          dataIndex: 'attachment',
          scopedSlots: { customRender: 'imgSlot' },
          sorter: true
        },
        {
          title: '处理方式',
          align: 'center',
          width: 100,
          dataIndex: 'disposal_dictText',
          customRender: forceNowrap
        },
        {
          title: '告警分类',
          align: 'center',
          width: 100,
          dataIndex: 'alertType_dictText',
          customRender: forceNowrap
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/alert/iotAlert/list'
      }
    }
  },
  created() {
    let processId = this.$route.query.processId
    this.queryParam.processId = processId
    this.loadData()
  },
  methods: {
    topoJump(data) {
      this.curTopo = data
      this.queryParam.processId = this.curTopo.processId
      this.loadData()
    }
  }
}
</script>

<style sccoped>

.flex-column {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.flex-fill {
  flex: 1;
}

</style>
